import axios from './axiosInstance';

// 방명록
export const getGuestbookList = () =>
  axios.get('/wedding/guestbook/list');

export const addGuestbook = (data) =>
  axios.post('/wedding/guestbook', data);

export const deleteGuestbook = (guestbookId, password) =>
  axios.delete(`/wedding/guestbook/${guestbookId}`, { params: { password } });

// 이벤트 업로드 (S3 presigned PUT)
export const presignUpload = (data) =>
  axios.post('/wedding/upload/presign', data);

export const completeUpload = (data) =>
  axios.post('/wedding/upload/complete', data);
